// Convert a public podcast/episode page URL into an embeddable player URL.
// Returns { embed, listen, platform }.
export const toPodcastEmbed = (raw) => {
  if (!raw) return { embed: null, listen: null, platform: null };
  const url = raw.trim();
  let u;
  try { u = new URL(url); } catch { return { embed: url, listen: url, platform: null }; }
  const host = u.hostname.replace(/^www\./, '');

  if (host === 'open.spotify.com') {
    const parts = u.pathname.split('/').filter(Boolean);
    const idx = parts.indexOf('embed');
    const clean = idx === -1 ? parts : parts.filter((_, i) => i !== idx);
    const cleanNoLocale = clean.length > 2 && /^[a-z]{2}(-[A-Z]{2})?$/.test(clean[0]) ? clean.slice(1) : clean;
    const [type, id] = cleanNoLocale;
    if (type && id) {
      return {
        embed: `https://open.spotify.com/embed/${type}/${id}?utm_source=generator&theme=0`,
        listen: `https://open.spotify.com/${type}/${id}`,
        platform: 'Spotify',
      };
    }
  }

  if (host === 'podcasts.apple.com') {
    return { embed: url.replace('https://podcasts.apple.com', 'https://embed.podcasts.apple.com'), listen: url, platform: 'Apple Podcasts' };
  }

  if (host === 'youtube.com' || host === 'youtu.be' || host === 'm.youtube.com') {
    const id = host === 'youtu.be' ? u.pathname.slice(1) : u.searchParams.get('v') || u.pathname.split('/').pop();
    if (id) return { embed: `https://www.youtube.com/embed/${id}`, listen: url, platform: 'YouTube' };
  }

  if (host.endsWith('ivoox.com') && !u.pathname.includes('player_ej')) {
    const m = url.match(/_rf_(\d+)_1\.html/);
    if (m) return { embed: `https://www.ivoox.com/player_ej_${m[1]}_6_1.html`, listen: url, platform: 'iVoox' };
  }

  return { embed: url, listen: url, platform: null };
};
